module.exports = __webpack_public_path__ + "static/media/400112_02.7b579be5.png";